import React, { useMemo } from "react";
import { TooltipContainer } from "@outplayed/tooltips";
import { getTierColor } from "@ugg/shared/dist/utils/rank-helpers";
import { capitalizeFirstLetter, convertRomanNumeral } from "lib/general-helper";
import { useProfileHistoricRanks } from "api/summonerProfileApi";
import { seasonMap } from "@ugg/shared/dist/constants/seasons";

const HistoricRanks = (props) => {
  const { summonerName, regionId, queueType } = props;
  const { data, loading, error } = useProfileHistoricRanks(summonerName, regionId, queueType);
  const { getHistoricRanks } = data || {};

  const historicData = useMemo(() => {
    return ((Array.isArray(getHistoricRanks) && getHistoricRanks) || [])
      .filter((historicRank) => !!historicRank.season && !!historicRank.tier)
      .sort((a, b) => b.season - a.season);
  }, [getHistoricRanks]);

  if (historicData.length === 0) {
    return null;
  }

  return (
    <div className="historic-ranks-row">
      {historicData.map((el) => {
        const { season, split } = seasonMap[el.season] || {};
        const seasonText = split ? `${season}-${split}` : season;
        return (
          <TooltipContainer
            key={el.season}
            tooltipInfo={`${capitalizeFirstLetter(el.tier)} ${convertRomanNumeral(el.rank)} ${
              !isNaN(parseInt(el.lp)) ? `${el.lp}LP` : ""
            }`}
            disableTooltip={!el.rank}
          >
            <div className="historic-rank">
              <span>
                <strong>S{seasonText}</strong>{" "}
                <span style={{ color: getTierColor(el.tier) }}>{capitalizeFirstLetter(el.tier)}</span>
              </span>
            </div>
          </TooltipContainer>
        );
      })}
    </div>
  );
};

export default HistoricRanks;
